import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Cookie } from "lucide-react";
import { Button } from "./ui/button";
import { getConsent, setConsent, loadAnalytics } from "../lib/consent";

// Bottom cookie-consent banner. Analytics (Clarity) load only after "Accept".
export default function CookieConsent() {
  const { t } = useTranslation();
  const [show, setShow] = useState(false);

  useEffect(() => {
    const c = getConsent();
    if (c === "accepted") loadAnalytics();     // returning visitor who already opted in
    else if (!c) setShow(true);                // first visit → ask
  }, []);

  const decide = (value) => {
    setConsent(value);
    if (value === "accepted") loadAnalytics();
    setShow(false);
  };

  if (!show) return null;
  return (
    <div className="fixed inset-x-0 bottom-0 z-[60] p-3 sm:p-4" data-testid="cookie-consent">
      <div className="mx-auto max-w-3xl rounded-2xl border border-border bg-card shadow-lg p-4 sm:p-5 flex flex-col sm:flex-row sm:items-center gap-3 sm:gap-5">
        <div className="flex items-start gap-3 flex-1">
          <Cookie className="h-6 w-6 text-[hsl(var(--accent))] shrink-0 mt-0.5" />
          <p className="text-sm text-foreground/85 leading-relaxed">{t("cookies.text")}</p>
        </div>
        <div className="flex items-center gap-2 shrink-0">
          <Button variant="ghost" size="sm" onClick={() => decide("declined")} data-testid="cookie-decline">{t("cookies.decline")}</Button>
          <Button size="sm" className="bg-[hsl(var(--accent))] text-white" onClick={() => decide("accepted")} data-testid="cookie-accept">{t("cookies.accept")}</Button>
        </div>
      </div>
    </div>
  );
}
